import {
  createContext,
  Dispatch,
  SetStateAction,
  useState,
  ReactNode,
} from 'react'

interface ContextType {
  email: string
  setEmail: Dispatch<SetStateAction<string>>
  verificationCode: string
  setVerificationCode: Dispatch<SetStateAction<string>>
}

const Contexts = createContext<ContextType>({
  email: '',
  setEmail: () => {},
  verificationCode: '',
  setVerificationCode: () => {},
})

const ContextProvider = ({ children }: { children: ReactNode }) => {
  const [email, setEmail] = useState('')
  const [verificationCode, setVerificationCode] = useState('')

  return (
    <Contexts.Provider
      value={{ email, setEmail, verificationCode, setVerificationCode }}
    >
      {children}
    </Contexts.Provider>
  )
}

export { ContextProvider, Contexts }
